var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgContactinline = function SvgContactinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#222",
    d: "M13.355 13.705H2.645a2 2 0 0 1-2-2v-6.41a2 2 0 0 1 2-2h10.71a2 2 0 0 1 2 2v6.41a2 2 0 0 1-2 2Zm-10.71-9.91a1.5 1.5 0 0 0-1.5 1.5v6.41a1.5 1.5 0 0 0 1.5 1.5h10.71a1.5 1.5 0 0 0 1.5-1.5v-6.41a1.5 1.5 0 0 0-1.5-1.5H2.645Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#222",
    d: "M8 9.895A2 2 0 0 1 6.795 9.5L.955 5.078a.25.25 0 1 1 .295-.398l5.845 4.413a1.5 1.5 0 0 0 1.81 0L14.75 4.68a.25.25 0 0 1 .402.131.25.25 0 0 1-.1.267L9.206 9.5A2 2 0 0 1 8 9.895Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#222",
    d: "M1.043 12.66a.25.25 0 0 1-.165-.435l4.597-4.102a.252.252 0 1 1 .333.377L1.21 12.598a.25.25 0 0 1-.167.062Zm13.915 0a.25.25 0 0 1-.168-.062L10.193 8.5a.25.25 0 1 1 .332-.372l4.598 4.097a.25.25 0 0 1-.064.414.25.25 0 0 1-.101.021Z"
  })));
};
export default SvgContactinline;